module.exports = __webpack_public_path__ + "static/media/currency-line.027f7e73.svg";